/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const societaDtoSchema = z.object({
  id: z.coerce.number().int(),
  name: z.coerce.string(),
});
